module.exports = __webpack_public_path__ + "static/media/hazardousdriving-icon.6c0d487c.svg";